import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { SalesTransactionService } from "src/app/core/services/sales/transactions/salestransaction.service.service";
import { ApiService } from "src/app/services/api";

@Component({
  selector: "app-transaction-order-edit-shared",
  templateUrl: "./transaction-order-edit-shared.component.html",
  styleUrls: ["./transaction-order-edit-shared.component.scss"],
})
export class TransactionOrderEditSharedComponent implements OnInit {
  @ViewChild("ngOtpInput", { static: false }) ngOtpInputRef: any;
  configTwo = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: "-",
    inputStyles: {
      width: "20.5%",
      height: "60px",
      fontSize: "13px",
      padding: "15px",
      marginRight: "20px",
      marginTop: "15px",
      marginBottom: "15px",
      textAlign: "center",
    },
  };
  @Input() timerDisplay: string;
  @Input() timeToVerify: any;
  @Input() buttonApprove: Boolean;
  @Input() orderEditModalPageOne: Boolean;
  @Input() orderEditModalPageTwo: Boolean;
  @Input() orderEditModalPageThree: Boolean;
  @Input() paymentReceipt: any;
  @Input() currency: any;
  @Input() employees: any[];
  @Input() userSelected: any;
  @Input() editPayment: any;
  @Input() tipAmount: any;
  @Input() chageLoader: Boolean;
  @Output() otpEmit: EventEmitter<any> = new EventEmitter();
  @Output() nextPage: EventEmitter<any> = new EventEmitter();
  @Output() selectTransactionEditOrder: EventEmitter<any> = new EventEmitter();
  @Output() changeValueSelect: EventEmitter<any> = new EventEmitter();
  @Output() changeAmount: EventEmitter<any> = new EventEmitter();
  @Output() changeTipFunction: EventEmitter<any> = new EventEmitter();
  @Output() resendOtpEditOrder: EventEmitter<any> = new EventEmitter();
  otp: Number;

  GLOBALURL: String = this.ApiService.getBaseURL();
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };

  otpStateManage: Boolean = false;
  constructor(private toastr: AlertService,
    private transactionService: SalesTransactionService,
    private ApiService: ApiService,
    private cookieService: CookieService,
    private http: HttpClient,) {}

  nCurrency: any;
  ngOnInit(): void {
    if (this.currency == undefined || this.currency == null || this.currency == "") {
      this.nCurrency = "$";
    } else {
      this.nCurrency = this.currency;
    }

    this.account = this.cookieService.get("loggedAccount");
    // {{ payment.orderId.orderSellStatus == 3 ? "Paid" : "Completed" }}
    if(this.paymentReceipt.serverId) {
      this.userSelected = this.paymentReceipt.serverId.employeeId;
    }
    if (!Boolean(this.currency)) {
      this.currency = "$";
    }
    console.log("this.userSelected", this.userSelected);
    console.log("EDIT_ORDER_RECIEPT", this.paymentReceipt);
    console.log("this.employees", this.employees);
    console.log("this.account", this.account);
  }


  idInterval: any;
  // timeToVerify: any = 0;
  runTime() {
    let ini = 0;
    this.timeToVerify = 120;
    this.idInterval = setInterval(() => {
      if (this.timeToVerify > 0) {
        this.timeToVerify = this.timeToVerify - 1;
      } else if (this.timeToVerify >= 0 && ini < 2 && this.orderEditModalPageTwo == false && this.orderEditModalPageOne == true) {
        console.log("OTP code has expired")
        this.toastr.error("OTP code has expired");
        ini++;
        clearInterval(this.idInterval);
      } else if (this.timeToVerify >= 0 && ini < 2 && this.orderEditModalPageTwo == true && this.orderEditModalPageOne == false) {
        // this.toastr.error("OTP code has expired");
        console.log("OTP VERIFIED AND MOVED TO NEXT STAGE")
        ini++;
        clearInterval(this.idInterval);
      }
    }, 1000);
  }

  account: any = "";
  isVerificationOk(code) {
    var parameters: any;
    if (
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.account
      )
    ) {
      parameters = {
        otp: code,
        username: this.account,
      };
    } else {
      parameters = {
        otp: code,
        mobile: this.account,
      };
    }
    return this.http
      .post(this.GLOBALURL + "/user/verifyOTP", parameters, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success == 1) {
            this.otpStateManage = false;
            this.buttonApprove = true;
            this.otpErrorMsg = "";
            this.nextPageFunc();
            clearInterval(this.idInterval);
            // this.buttonApprove = true;
            // this.toastr.success(response.message);
            // clearInterval(this.idInterval);
          } else {
            this.otpStateManage = false;
            this.buttonApprove = false;
            this.otpErrorMsg = response.message;
          }
        }, (error) => {
              console.log(error)
              this.otpStateManage = false;
              this.otpErrorMsg = "Invalid username or OTP";
            }
      );
  }

  changeOtp(event) {
    console.log("event", event)
    var code = +event;
    this.otp = code;
    console.log("this.otp", this.otp)
    if (this.otp && this.otp.toString().length == 4) {
      this.otpStateManage = true;
      this.isVerificationOk(this.otp);
      // this.otpEmit.emit(this.otp);
      // this.transactionService.isVerificationOk(this.otp).subscribe(
      //   (response: any) => {
      //     if (response.success == 1) {
      //       this.otpStateManage = false;
      //       this.buttonApprove = true;
      //       this.otpErrorMsg = "";
      //       this.nextPageFunc();
      //       clearInterval(this.idInterval);
      //     } else {
      //       this.otpStateManage = false;
      //       this.buttonApprove = false;
      //       this.otpErrorMsg = response.message;
      //     }
      //   }, (error) => {
      //     console.log(error)
      //     this.otpStateManage = false;
      //     this.otpErrorMsg = "Invalid username or OTP";
      //   }
      // );
    }
    // else
    //   this.toastr.error("please fill the otp");
  }
  nextPageFunc() {
    this.otpErrorMsg = "";
    // if (this.otp && this.otp.toString().length == 4) {
    //   this.otpEmit.emit(this.otp);
    // }
    // else
    //   this.toastr.error("please fill the otp");
    // if (this.buttonApprove) {
    //   this.orderEditModalPageOne = false;
    //   this.orderEditModalPageTwo = true
    // }
    this.nextPage.emit();
    // this.selectTransactionEditOrderFunc();
  }
  clearOtp() {
    this.ngOtpInputRef.setValue("");
  }
  selectTransactionEditOrderFunc(
    transaction: any,
    paymentReceipt: any,
    index: any
  ) {
    var details = {
      transaction,
      paymentReceipt,
      index,
    };
    console.log("TRANSACTION_EDIT_ORDER_FUNC", details)
    this.selectTransactionEditOrder.emit(details);
  }
  changeValueSelectFunc(event) {
    console.log(event);
    this.changeValueSelect.emit(event);
  }

  tipAmt;
  tipAmtValidation= true;
  errorMsg = "";
  otpErrorMsg = "";
  // change(event: any) {
  //   console.log("event", event.value)
  //   let data = event.value.replace(/\$/g, "");
  //   if (data && data < 0) {
  //     this.tipAmt= data;
  //     this.tipAmtValidation=false;
  //     this.errorMsg = "Please add valid tip amount";
  //     // this.toastr.error("Please add valid tip amount");
  //   } else {
  //     this.errorMsg = "";
  //     this.tipAmt = data;
  //     this.tipAmtValidation=true;
  //     this.changeAmount.emit(data);
  //   }
  // }

  change(event: any) {
    console.log("event", event.value)
    // Remove all non-digit and non-decimal point characters
    let data = event.value.replace(/[^0-9.]/g, "");

    console.log("DATA11", data)
    // Split the string into the integer and decimal parts
    let [integer, decimal] = data.split('.');

    // Limit the integer part to 4 digits
    if (integer.length > 4) {
        integer = '0';
        // do same for decimal
        decimal = '00';
    }

    // If there is a decimal part, limit it to 2 digits
    if (decimal) {
        if (decimal.length > 2) {
            decimal = decimal.slice(0, 2);
            console.log("DECIMAL_MORE_THAN_2")
        }
        // Combine the integer and decimal parts
        data = `${integer}.${decimal}`;
    } else {
        data = integer;
    }

    // Convert the string to a number
    data = parseFloat(data);

    console.log("DATA222", data)
    if (data && data < 0) {
        this.tipAmt= data;
        this.tipAmtValidation=false;
        this.errorMsg = "Please add valid tip amount";
        // this.toastr.error("Please add valid tip amount");
    } else {
        this.errorMsg = "";
        this.tipAmt = data;
        console.log("this.tipAmt3333", this.tipAmt)
        this.tipAmtValidation=true;
        this.changeAmount.emit(data);
    }
}
  changeTipFunc() {
    // console.log("this.tipAmt", this.tipAmt)
    if(this.paymentReceipt.transactionIds) {
      if(this.tipAmt){
        if(this.tipAmtValidation){
          console.log("TIP_AMOUNT_NOT_EMPTY");
          this.errorMsg = "";
          this.changeTipFunction.emit();
        } else{
          this.errorMsg = "Please add valid tip amount";
          // this.toastr.error("Please add valid tip amount");
        }
      } else if(this.tipAmt == undefined || this.tipAmt == null || this.tipAmt == 0) {
        this.tipAmt = this.tipAmount;
        console.log("TIP_AMOUNT_EMPTY");
        console.log("this.tipAmt", this.tipAmt);
        if(this.paymentReceipt.orderId.orderSellStatus == 3 && this.paymentReceipt.transactionIds[0].transactionStatus != 7) {
          if(this.tipAmt < 0) {
            this.errorMsg = "Please add tip amount";
          } else {
            this.errorMsg = "";
            this.changeTipFunction.emit();
          }
        } else {
        this.errorMsg = "";
        this.changeTipFunction.emit();
        }
      } else{
        console.log("this.tipAmt_ERROR", this.tipAmt);
        this.errorMsg = "Please add tip amount";
        // this.toastr.error("Please add tip amount");
      }
    } else {
      this.errorMsg = "";
      this.changeTipFunction.emit();
    }
  }
  resendOtpEditOrderFunc() {
    this.resendOtpEditOrder.emit();
  }

  //
  limitInput(input: HTMLInputElement) {
    // Remove all characters that are not digits or a decimal point
    let value = input.value.replace(/[^0-9.]/g, '');

    // Split the string into the integer and decimal parts
    let [integer, decimal] = value.split('.');

    // Limit the integer part to 4 digits
    if (integer.length > 4) {
      integer = integer.slice(0, 4);
    }

    // If there is a decimal part, limit it to 2 digits
    if (decimal) {
      if (decimal.length > 2) {
        decimal = decimal.slice(0, 2);
      }

      // Combine the integer and decimal parts
      value = `${integer}.${decimal}`;
    } else {
      value = integer;
    }

    // Update the input value
    input.value = value;

    // Update the model value
    this.tipAmount = parseFloat(value);
  }
}
